import React from 'react';
import { FormattedMessage, defineMessage } from 'react-intl';
import { EventbritePlusLogo } from '@/components/_shared/Icons';
import styles from './EarlyAccessStrip.module.scss';

const EARLY_ACCESS_MESSAGES = {
  announcement: defineMessage({
    id: 'Early access',
    defaultMessage: 'Early access',
    description: 'Label on the Eventbrite+ Early Access strip before the purchase window opens',
  }),
  open: defineMessage({
    id: 'Your 2-hour early access is <open>open</open>',
    defaultMessage: 'Your 2-hour early access is <open>open</open>',
    description: 'Label on the Eventbrite+ Early Access strip while the purchase window is open',
  }),
};

// TEMPORARY IMPLEMENTATION — replace with the shared Marmalade badge when available.
//
// The Figma design (node 30992:9326) specifies a Marmalade `Badge` with
// `variant="brand-primary"`, `labelStyle="signal"`, `size="SM"` and `bordered={false}`.
// The Marmalade version this app installs (`@eventbrite/marmalade` 8.27.0) does NOT support
// any of those props — its `Badge` only accepts `variant` in
// `info | opportunity | success | warning | danger | bold | custom` and a boolean `bordered`
// (see `node_modules/@eventbrite/marmalade/lib/components/Badge/Badge.d.ts`). Passing the Figma
// props would silently render the wrong badge, so this strip is hand-built from the design
// tokens instead:
//   - background  color/neutral/100              #f8f7fa  ($color-bg-sunken)
//   - text        desktop/body/body-medium-bold  14/20    Founders Grotesk R Medium
//   - text color  text-color/heading/heading-primary   #261b36  ($color-fg-base)
//   - icon        dimension/size/icon/sm         20px
// The Eventbrite+ logo is a literal clone for the same reason (see `EventbritePlusLogo.tsx`).
// Once Marmalade ships the `brand-primary`/`signal` Badge used in Figma, swap this whole strip
// for `<Badge variant="brand-primary" labelStyle="signal" size="SM" bordered={false}
// icon={<EventbritePlusLogo />}>` and delete the local component + SCSS.
export const EarlyAccessStrip: React.FC<{ phase: 'announcement' | 'open' }> = ({ phase }) => (
  <div className={styles.strip} data-testid="early-access-strip">
    <EventbritePlusLogo className={styles.logo} />
    {/* One flex item, so the strip's `gap` cannot land between the text and the "open" tag. */}
    <span>
      <FormattedMessage
        {...EARLY_ACCESS_MESSAGES[phase]}
        values={{ open: (chunks) => <span className={styles.phaseOpen}>{chunks}</span> }}
      />
    </span>
  </div>
);
